import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

type URLStatic = typeof URL;

@Injectable()
export class FileSaverService {
  private documentRef: Document;
  private windowRef: any;

  constructor(@Inject(DOCUMENT) documentRef: any) {
    this.documentRef = documentRef;
    this.windowRef = this.documentRef.defaultView!;
  }

  save(
    filename: string,
    content: Blob | File | string,
    contentType?: string
  ): void {
    const URL: URLStatic = this.windowRef.URL;

    let blob: Blob;

    if (content instanceof Blob) {
      blob = content;
    } else {
      blob = new Blob([content], {
        type: contentType!
      });
    }

    let url: string = URL.createObjectURL(blob);

    this.saveFromUrl(filename, url);

    URL.revokeObjectURL(url);
  }

  saveFromUrl(filename: string, url: string): void {
    let anchor: HTMLAnchorElement = this.documentRef.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.target = "_blank";

    this.documentRef.body.appendChild(anchor);
    anchor.click();
    this.documentRef.body.removeChild(anchor);
  }
}
